import React from "react";
import { View, Text, TouchableOpacity, Linking, Platform } from "react-native";
import { getVersion } from "react-native-device-info";
import InAppBrowser from "react-native-inappbrowser-reborn";
import Icon from "react-native-vector-icons/Feather";

import { Navigator } from "router";
import { PRIVACY_POLICY_URL } from "apis";
import { useAppInfo } from "screens/main/hooks";
import { styles } from "screens/main/themeA/styles";

const isNative = Platform.OS !== "web";

const TakerDetails = () => {
  const { taker, division, isConnected, getBuildEnv } = useAppInfo();
  return (
    <View style={styles.footer}>
      {taker.id && (
        <TouchableOpacity
          activeOpacity={1}
          onLongPress={() => Navigator.jumpTo("stats")}
        >
          <View style={styles.takerDetail}>
            <Text style={styles.takerDetailText}>
              Served by: {taker.first_name + " " + taker.last_name}
            </Text>
            <Text style={styles.takerDetailText}>
              {division.title + getBuildEnv()}
            </Text>
          </View>
        </TouchableOpacity>
      )}
      <Text style={styles.policy} onPress={openLink}>
        Data &amp; Privacy Policy
      </Text>
      {isNative && (
        <View style={styles.appInfo}>
          <View style={styles.iconContainer}>
            <Icon
              size={styles._icon?.fontSize}
              name={isConnected ? "wifi" : "wifi-off"}
              color={styles._icon?.color}
            />
          </View>
          <Text style={styles.appVersion}>
            {isNative && "v" + getVersion()}
          </Text>
        </View>
      )}
    </View>
  );
};

const openLink = async () => {
  const url = PRIVACY_POLICY_URL;
  if (isNative) {
    try {
      if (isNative && (await InAppBrowser.isAvailable())) {
        await InAppBrowser.open(url);
      } else {
        Linking.openURL(url);
      }
    } catch (e) {}
  } else {
    window.open(url, "_blank");
  }
};

export default TakerDetails;
